import useLazySelector, { isNotCustomer } from "common/redux/useLazySelector";
import { PositionSetting } from "domain/positionSetting";
import { loadPositionSettings } from "./longShort.actions";

const defaultVal: PositionSetting[] = [];
export default function usePositionSettings(): PositionSetting[] {
    return useLazySelector(m => m.positionSettings, dispatch => loadPositionSettings()(dispatch), isNotCustomer, defaultVal);
}

export function usePositionSettingsForCommodity(commodityId: number): PositionSetting[] {
    const positionSettings = usePositionSettings();

    return positionSettings.filter(m => m.commodity.id === commodityId);
}